import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Loader({ label = "Chargement…" }) {
  return (
    <div data-testid="page-loader" className="flex min-h-[50vh] flex-col items-center justify-center gap-3 text-[color:var(--muted-ink)]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[color:var(--line)] border-t-[color:var(--terracotta)]" />
      <p className="font-display text-lg">{label}</p>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user === false) return <Navigate to="/connexion" replace />;
  return children;
}
